<script setup>
const { locale, t } = useI18n();
const localePath = useLocalePath();
const gtm = useGtm();

const { data } = defineProps(['data']);

const paddingTop = () => {
  const { width, height } = data.image_list ? data.image_list : this.defaultImageSize;
  return `${(height / width) * 100}%`;
};

const track = (eventId) => {
  gtm.trackEvent({
    event: 'eventDetail_select',
    eventId,
    url: window.location.pathname,
  });
};

const datesToArray = (start, end) => {
  const array = {
    start_at: {
      timestamp: start,
    },
    end_at: {
      timestamp: end,
    },
  };

  return array;
};
</script>

<template>
  <nuxt-link
    v-if="data.id"
    :to="
      localePath({
        name: 'event-id-slug',
        params: {
          id: data.id,
          slug: data.seo_url_slug[locale],
        },
      })
    "
    class="event-wall-item"
    data-heading-hover
  >
    <div ref="imageWrapper" class="event-wall-item__image-wrapper" :style="{ paddingTop }">
      <img
        :src="useGetImageUrl(data.image_mobile || data.image_list?.url || data.image_detail?.url || '/img/dummy/ngp.png', 400)"
        class="event-wall-item__image event-wall-item__image--mobile"
        :alt="data.image_mobile_description || data.image_list_description || data.image_detail_description || data.name"
      />
      <img
        :src="useGetImageUrl(data.image_list?.url || data.image_mobile || data.image_detail?.url || '/img/dummy/ngp.png', 400)"
        class="event-wall-item__image event-wall-item__image--desktop"
        :alt="data.image_list_description || data.image_mobile_description || data.image_detail_description || data.name"
      />

      <span v-if="data.ends_soon" class="event-wall-item__tag"> <Tag :content="t('pages.events.ends-soon')" /></span>
      <span v-if="data.online && data.dates[0] && Date.now() < data.dates[0].start_at.timestamp * 1000" class="event-wall-item__tag">
        <Tag :content="t('pages.events.upcoming')" :blue="true" />
      </span>
    </div>
    <div class="event-wall-item__main">
      <div class="event-wall-item__type">
        <div v-if="data.categories && Object.keys(data.categories).length > 0">
          <span v-for="(category, key) in data.categories" :key="key"> {{ category.name }}<span v-if="data.categories.length - 1 > key">, </span> </span>
        </div>
        <div v-else>
          {{ t(`global.event-types.${data.type.toUpperCase()}`) }}
        </div>
      </div>
      <div class="event-wall-item__title">
        <h3 class="heading heading--3">
          <span class="heading__link" v-html="data.name" />
        </h3>
      </div>
      <div
        v-if="(data.effective_start_date && data.effective_start_date.timestamp && data.effective_end_date && data.effective_end_date.timestamp) || data.dates.length || data.buildings"
        class="event-wall-item__meta"
      >
        <ul class="list">
          <!-- <template v-if="!data.online"> -->
          <template v-if="data.dates.length">
            <li v-if="data.dates.length && data.type !== 'exposition'" class="event-wall-item__meta-item">
              {{ useDateRange(data.dates) }}
            </li>
          </template>
          <!-- <template v-else-if="data.effective_start_date && data.effective_start_date.timestamp && data.effective_end_date && data.effective_end_date.timestamp">
            <li v-if="data.type !== 'exposition'" class="event-wall-item__meta-item">
              {{ datesToArray(data.effective_start_date.timestamp, data.effective_end_date.timestamp) | dateRange }}
              version b
            </li>
          </template> -->
          <!-- </template> -->
          <!-- <template v-else>
            <li v-if="data.online && data.dates[0].start_at.timestamp * 1000 > Date.now()">
              {{ data.dates[0].start_at.timestamp | date }}
              version c
            </li>
          </template> -->
          <template v-if="data.buildings && !data.online">
            <li class="event-wall-item__meta-item">
              <span v-for="(item, index) in data.buildings" :key="index"><template v-if="index != 0">, </template>{{ item.name }}</span>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </nuxt-link>
</template>

<style lang="scss" scoped>
.event-wall-item {
  $s: &;
  text-decoration: none;

  &__image-wrapper {
    position: relative;
    overflow: hidden;
    //padding-top: 100% !important;
  }

  &__image {
    //@include overlay;
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.2s;
  }

  &__tag {
    bottom: 10px;
    left: 10px;
    position: absolute;
  }

  &__main {
    padding-top: 20px;
  }

  &__type {
    margin-bottom: 5px;
    font-weight: $font-weight-medium;
    font-size: 12px;
    text-transform: uppercase;
  }

  &__title {
  }

  &__title-text {
    display: inline;
    background: linear-gradient(currentColor, currentColor);
    background-position: 0% 92%;
    background-repeat: no-repeat;
    background-size: 0% 2px;
    transition: background-size 0.3s;
  }

  &__meta {
    margin-top: 10px;
  }

  &__meta-item {
  }

  &:hover {
    #{$s}__title-text {
      background-size: 100% 2px;
    }

    #{$s}__image {
      transform: scale(1.1);
    }
  }
}

.event-wall-item__image-wrapper {
  @media (max-width: 768px) {
    aspect-ratio: 1 / 1;
    width: 100%;
    max-height: 100%;
  }
}

.event-wall-item__image--desktop {
  @media (max-width: 992px) {
    display: none;
  }
}

.event-wall-item__image--mobile {
  @media (min-width: 993px) {
    display: none;
  }
}
</style>
